<script>
  import { onMount } from "svelte";
  import CreateRuleModal from "../admin/modals/CreateRuleModal.svelte";
    import { toasts } from "../../stores/ToastStore";
  let rules = $state([]);
  let showCreateModal = $state(false);
  onMount(async () => rules = await window.api.admin.readSessionRules.query());

  $effect(async () => {
    // TODO: Does not refetch on adding a rule
    showCreateModal;
    console.log('Refetch; rules')
    rules = await window.api.admin.readSessionRules.query();
  })

  async function submitDelete(id) {
    const r = await window.api.admin.deleteSessionRule.mutate({ id });

    if("affected" in r && r.affected == 1) {
      rules = await window.api.admin.readSessionRules.query();
      toasts.success("Deleted session rule")
    } else {
      toasts.error("Failed to remove session rule")
    }
  }
</script>

<div class="container">
  <div class="row">
    <div class="col-12">
      <header class="page-header d-print-none py-3">
        <div class="row align-items-center">
          <div class="col">
            <h2 class="page-title">Session Rules</h2>
          </div>

          <div class="col-md-auto ms-auto d-print-none">
            <div class="btn-list">
              <button onclick={() => showCreateModal = !showCreateModal} class="btn btn-sm btn-success">Create Rule</button>
            </div>
          </div>
        </div>
      </header>

      <div class="card">
        <div class="table-responsive">
          <table class="table table-vcenter card-table table-striped">
            <thead>
              <tr>
                <th>IP</th>
                <th>Country</th>
                <th>Expiry</th>
                <th>Comment</th>
                <th class="w-1"></th>
              </tr>
            </thead>
            <tbody>
              {#each rules as rule}
                <tr>
                  <td>{rule.ip_address}</td>
                  <td>{rule.country_iso_code}</td>
                  <td>{rule.expiry_in_seconds}</td>
                  <td class="text-secondary">{rule.comment}</td>
                  <td>
                    <button class="badge bg-danger" onclick={async () => submitDelete(rule.id)}>Delete</button>
                  </td>
                </tr>
              {/each}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>

<CreateRuleModal showModal={showCreateModal} />